import { useDataModel } from '@thd-nucleus/data-sources';
import { orderDetailsDataModel, buildOrderDetailsVariables, OrderDetailsQueryParams } from './orderDetailsDataModel';
import { RawOrderDetailsResponse } from './types';
import { QueryResult, toQueryResult } from './queryResult';

const PLACEHOLDER_VARIABLES = { userId: '', headers: { omsVersion: 'v2' }, request: {} };

/**
 * `orderDetailsParams === null` means "not ready to fetch yet" — the query is skipped and no
 * variables are sent. For AllOrdersTable this means a row that hasn't scrolled into view (see
 * useRowsInView) never triggers this query; for ActiveOrdersTable's fulfillment drawer it means the
 * drawer isn't open, or the selected active order doesn't carry enough identifying data (see
 * adapters/fulfillmentDrawer.ts's buildActiveOrderDetailsParams) — the drawer then renders from the
 * raw activeOrders distribution alone.
 */
export function useOrderDetailsQuery(orderDetailsParams: OrderDetailsQueryParams | null): QueryResult<RawOrderDetailsResponse> {
  const skip = orderDetailsParams === null;
  const variables = orderDetailsParams ? buildOrderDetailsVariables(orderDetailsParams) : PLACEHOLDER_VARIABLES;

  const response = useDataModel('orderDetails', {
    variables,
    dataModel: orderDetailsDataModel,
    skip,
    context: { withAuth: true }
  });

  return toQueryResult<RawOrderDetailsResponse>(
    { ...response, data: response.data?.orderDetails },
    skip
  );
}
